import { getBPMTsAuthUrl, matchHmac, updateCredentialsToFirestore, geLighthouseUrl } from '@/utils/misc'

/**
 * @description Do auth for shopify. Get auth url from BPM API and redirect to it or else we got the code and use it to get token
 * @param {Object} params
 * @param {string} params.appSlug
 * @param {Object} [params.params]
 * @param {string} params.apiKey
 * @returns {Promise<Object>}
 */
export default async ({ appSlug, params = {}, apiKey }) => {
  if (!params.hmac) throw new Error('HMAC is missing from the params.')

  const { hmac, ...paramsWithoutHmac } = params
  const hmacMatched = await matchHmac({ hmac, apiKey, appSlug, message: new URLSearchParams(paramsWithoutHmac).toString() })
  if (!hmacMatched) throw new Error('Unable to verify the request params.')

  const shopName = params.shop.split('.')[0]

  if (params.code) {
    return {
      ...params,
    }
  } else {
    await updateCredentialsToFirestore(appSlug, { shopName })
    window.location.href = getBPMTsAuthUrl({ apiToken: apiKey, appName: appSlug, frontUrl: geLighthouseUrl('/settings') })
  }
}
